import { Injectable } from "@angular/core";
import { BehaviorSubject, merge, Observable, of } from "rxjs";
import { UpsertProjectCo2Request, ProjectCo2Client } from "../WebApiClient";
import { publishReplay, refCount, switchMap } from "rxjs/operators";

@Injectable()
export class ProjectCo2Service {
    private projectCo2Trigger = new BehaviorSubject(true);

    public constructor(private readonly projectCo2Client: ProjectCo2Client) {}

    getProjectCo2(): Observable<UpsertProjectCo2Request | undefined> {
        let projectCo2Observable = this.projectCo2Trigger.pipe(
            switchMap((_) => merge(of(undefined), this.projectCo2Client.get())),
            publishReplay(2),
            refCount()
        );

        return projectCo2Observable;
    }

    async upsert(projectCo2: UpsertProjectCo2Request) {
        this.projectCo2Trigger.next(false);
        let o = await this.projectCo2Client
            .upsertProjectCo2(projectCo2)
            .pipe(publishReplay(2), refCount());
        o.toPromise().then((_) => this.projectCo2Trigger.next(true));
        return o;
    }
}
